import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=650002b0&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"
import style1 from "./Product.vue?vue&type=style&index=1&id=650002b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650002b0",
  null
  
)

export default component.exports